import { Inject, Injectable } from "@angular/core";
import { ApiEndPoint } from "./api-end-point";
import { ApiResultError, CheckUtils, OdConfig } from "..";
var ChatEndPoints = /** @class */ (function () {
    function ChatEndPoints(apiEndPoint, config) {
        this.apiEndPoint = apiEndPoint;
        this.config = config;
    }
    ChatEndPoints.prototype.chatSetting = function (uri) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.apiEndPoint.get('conversations/chatSettings', false, true, 'uri=' + uri).subscribe(function (res) {
                if (res instanceof ApiResultError) {
                    reject(res);
                }
                else {
                    resolve(res);
                }
            });
        });
    };
    ChatEndPoints.prototype.deanonymizeUser = function (deanonymizeUserApiData) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (CheckUtils.isEmpty(deanonymizeUserApiData.authenticationToken))
                return;
            _this.apiEndPoint.get('conversations/deanonymizeUser', false, true, 'token=' + deanonymizeUserApiData.authenticationToken, 'jabberId=' + deanonymizeUserApiData.jabberId).subscribe(function (res) {
                if (res instanceof ApiResultError) {
                    reject(res);
                }
                else {
                    resolve(res);
                }
            });
        });
    };
    ChatEndPoints.prototype.conversationsPage = function (conversationsApiData) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (CheckUtils.isEmpty(conversationsApiData.authenticationToken))
                return;
            _this.apiEndPoint.get('conversations/userRooms', false, true, 'token=' + conversationsApiData.authenticationToken, 'offset=' + conversationsApiData.offset, 'limit=' + conversationsApiData.limit).subscribe(function (res) {
                if (res instanceof ApiResultError) {
                    reject(res);
                }
                else {
                    resolve(res);
                }
            });
        });
    };
    ChatEndPoints.prototype.conversationsByJabberIds = function (conversationsByJabberIds) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (CheckUtils.isEmpty(conversationsByJabberIds.authenticationToken))
                return;
            _this.apiEndPoint.post('conversations/userRoomsByJabberIds', conversationsByJabberIds).subscribe(function (res) {
                if (res instanceof ApiResultError) {
                    reject(res);
                }
                else {
                    resolve(res);
                }
            });
        });
    };
    ChatEndPoints.prototype.getConversationRoomsByIds = function (conversationsByIds) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (CheckUtils.isEmpty(conversationsByIds.authenticationToken))
                return;
            _this.apiEndPoint.post('conversations/roomsByIds', conversationsByIds).subscribe(function (res) {
                if (res instanceof ApiResultError) {
                    reject(res);
                }
                else {
                    resolve(res);
                }
            });
        });
    };
    ChatEndPoints.prototype.getConversationRoomsByItemId = function (token, itemId, cpId) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (CheckUtils.isEmpty(itemId))
                return;
            _this.apiEndPoint.get(_this.config.conversationsApi + '/roomsByItemId', false, true, CheckUtils.isEmpty(token) ? null : 'token=' + token, 'itemId=' + itemId, CheckUtils.isEmpty(cpId) ? null : "cpId=" + cpId).subscribe(function (res) {
                if (res instanceof ApiResultError) {
                    reject(res);
                }
                else {
                    resolve(res);
                }
            });
        });
    };
    ChatEndPoints.prototype.getFilteredConversationRoomIds = function (token, offset, limit, conversationState, conversationVisibility, myConversations, myInbox) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.apiEndPoint.post(_this.config.conversationsApi + '/getFilteredConversationRoomIds', {
                token: token,
                offset: offset,
                limit: limit,
                conversationState: conversationState,
                conversationVisibility: conversationVisibility,
                myConversations: myConversations,
                myInbox: myInbox
            }, true).subscribe(function (res) {
                if (res instanceof ApiResultError) {
                    reject(res);
                }
                else {
                    resolve(res);
                }
            });
        });
    };
    ;
    ChatEndPoints.prototype.messagesPage = function (messagesApiData) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (CheckUtils.isEmpty(messagesApiData.roomId))
                return;
            if (CheckUtils.isEmpty(messagesApiData.authenticationToken)) {
                _this.apiEndPoint.get(_this.config.conversationsApi + '/roomMessages', false, true, 'roomId=' + messagesApiData.roomId, 'cpId=' + messagesApiData.cpId, 'offset=' + messagesApiData.offset, 'limit=' + messagesApiData.limit).subscribe(function (res) {
                    if (res instanceof ApiResultError) {
                        reject(res);
                    }
                    else {
                        resolve(res);
                    }
                });
            }
            else {
                _this.apiEndPoint.get(_this.config.conversationsApi + '/roomMessages', false, true, 'token=' + messagesApiData.authenticationToken, 'cpId=' + messagesApiData.cpId, 'roomId=' + messagesApiData.roomId, 'offset=' + messagesApiData.offset, 'limit=' + messagesApiData.limit).subscribe(function (res) {
                    if (res instanceof ApiResultError) {
                        reject(res);
                    }
                    else {
                        resolve(res);
                    }
                });
            }
        });
    };
    ChatEndPoints.prototype.conversationsStatistics = function (conversationsApiData) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.apiEndPoint.post(_this.config.conversationsApi + '/roomsData', conversationsApiData).subscribe(function (res) {
                if (res instanceof ApiResultError) {
                    reject(res);
                }
                else {
                    resolve(res);
                }
            });
        });
    };
    ChatEndPoints.prototype.defaultUserJid = function (token) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (CheckUtils.isEmpty(token))
                return;
            _this.apiEndPoint.get('conversations/defaultUserJid', false, true, 'token=' + token).subscribe(function (res) {
                if (res instanceof ApiResultError) {
                    reject(res);
                }
                else {
                    resolve(res);
                }
            });
        });
    };
    ChatEndPoints.prototype.getUnreadMessageJabberIds = function (conversationsApiData) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (CheckUtils.areEmpty(conversationsApiData.authenticationToken, conversationsApiData.roomIds))
                return;
            _this.apiEndPoint.post('conversations/getUnreadMessageJabberIds', conversationsApiData).subscribe(function (res) {
                if (res instanceof ApiResultError) {
                    reject(res);
                }
                else {
                    var map_1 = new Map();
                    Object.keys(res).forEach(function (key) { return map_1.set(Number(key), res[key]); });
                    resolve(map_1);
                }
            });
        });
    };
    ChatEndPoints.prototype.markMessagesAsRead = function (conversationsByJabberIdsApiData) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (CheckUtils.areEmpty(conversationsByJabberIdsApiData.authenticationToken, conversationsByJabberIdsApiData.jabberIds)) {
                resolve(true);
                return;
            }
            _this.apiEndPoint.post('conversations/markMessagesAsRead', conversationsByJabberIdsApiData).subscribe(function (res) {
                if (res instanceof ApiResultError) {
                    reject(res);
                }
                else {
                    resolve(res);
                }
            });
        });
    };
    ChatEndPoints.decorators = [
        { type: Injectable },
    ];
    /** @nocollapse */
    ChatEndPoints.ctorParameters = function () { return [
        { type: ApiEndPoint, },
        { type: OdConfig, decorators: [{ type: Inject, args: ['config',] },] },
    ]; };
    return ChatEndPoints;
}());
export { ChatEndPoints };
//# sourceMappingURL=chat-end-points.js.map


//////////////////
// WEBPACK FOOTER
// ../od-ts/dist/endpoints/chat-end-points.js
// module id = 250
// module chunks = 14